import { buildCtaUrl } from '../utils/attribution.js';

const APP_STORE = 'https://apps.shopify.com/account-editor';

export default function FinalCTA() {
  return (
    <section className="final-cta">
      <div className="final-cta__container">
        <div className="final-cta__left">
          <h2 className="final-cta__title">Own the post-purchase moment.</h2>
          <p className="final-cta__sub">
            Self-serve edits, cancel deflection, and one-click upsells — live in 5 minutes.
          </p>
        </div>

        <div className="final-cta__right">
          <a href={buildCtaUrl(APP_STORE, 'final-install')} className="btn btn--primary-lg">
            Install Free on Shopify <i className="ph ph-arrow-right" aria-hidden="true" />
          </a>
          <p className="final-cta__meta">14-day free trial · No credit card · Cancel anytime</p>
        </div>
      </div>
    </section>
  );
}
